import portalCommunication from '@3plearning/mathletics-portal-communication-service';

export const SHOW = 'SHOW_BUSY_INDICATOR';
export const HIDE = 'HIDE_BUSY_INDICATOR';

export const show = () => {
    portalCommunication.requestLoadingSpinner(true);
    return {
        type: SHOW
    };
};

export const hide = () => {
    portalCommunication.requestLoadingSpinner(false);
    return {
        type: HIDE
    };
};



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator-actions.js